module.exports = __webpack_public_path__ + "static/media/Volume_icn.a6f88084.svg";